import { SamplerComp } from './SamplerComp'
import { SeedComp } from './SeedComp'
import { CfgComp } from './CfgComp'
import { ClipSkipComp } from './ClipSkipComp'
import { EnsdComp } from './EnsdComp'
import { MyIcon } from '~/components/ui/MyIcon'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { CDNImage } from '~/components/business/CDNImage'
import Router from 'next/router'
import styles from '../AiForm.module.css'
import { useAtom } from 'jotai'
import {
  cfgAtom,
  clipSkipAtom,
  ensdAtom,
  initImageUrlAtom,
  selectSamplerAtom,
} from './atom'
import { message } from 'antd'
import { isNullOrUndefined } from '~/utils'
import { observer } from 'mobx-react'
import { useAuth } from '~/hooks/useAuth'
import { useType } from '../useType'
import { CutDiffProportion } from './CutDiffProportion'
import { CfgScale1 } from './CfgScale1'
import { CfgScale2 } from './CfgScale2'
import useOptions from './useOptions'
import { StylizeComp } from './StylizeComp'
import { ChaosComp } from './ChaosComp'

export const VipParamsComp = observer(() => {
  const { validateIsLogin } = useValidateAuth()
  const [selectSampler] = useAtom(selectSamplerAtom)
  const [cfg] = useAtom(cfgAtom)
  const [ensd] = useAtom(ensdAtom)
  const [clipSkip] = useAtom(clipSkipAtom)
  const { isVip, isHighUser } = useAuth()
  const { is4k } = useType()
  const { isFlux } = useOptions()
  const [initImageUrl] = useAtom(initImageUrlAtom)

  // 显示文生图IFG检索参数 （https://www.tapd.cn/57191511/prong/stories/view/1157191511001033936）
  const showIfgParams = !initImageUrl && isFlux

  return (
    <div className={styles.memberParamsWrap}>
      <div className="flex justify-between items-center mb-3">
        <div className="flex justify-between items-center text-neutral-600 text-xs">
          <CDNImage
            src={
              isVip
                ? '/images/ai/vip/vip.png'
                : '/images/ai/vip/vip-disabled.png'
            }
            className="w-5 mr-1"
          />
          <span>会员专享</span>
        </div>
        {!isVip ? (
          <div
            className="flex items-center text-xs pl-2 pr-0.5 rounded-3xl bg-[#281A54] text-primary cursor-pointer"
            onClick={() => {
              if (!validateIsLogin()) return
              Router.push('/member')
            }}
          >
            立即解锁
            <MyIcon icon="arrow-right-simple" className="text-[20px]" />
          </div>
        ) : (
          <div className="w-5 h-5 rounded-full bg-[#F9DEB9]/20 text-center p-[1px] leading-none">
            <MyIcon icon="check" className="text-[#D9D9D9] text-[18px]" />
          </div>
        )}
      </div>
      <div
        onClick={() => {
          if (!isHighUser) {
            message.destroy()
            message.info('开通会员解锁更多参数')
          }
        }}
      >
        {/** 采样模式-备注：部分模型不支持该参数 */}
        {!is4k && !isFlux && (
          <>
            {!isNullOrUndefined(selectSampler?.[0]) && (
              <SamplerComp disabled={!isHighUser} />
            )}
          </>
        )}

        {/* 随机种子 */}
        <SeedComp disabled={!isHighUser} />

        {/* 提示词相关性-备注：部分模型不支持该参数 */}
        {!is4k && (
          <>
            {!isNullOrUndefined(cfg) && (
              <CfgComp disabled={!isHighUser} max={isFlux ? 20 : 30} />
            )}
          </>
        )}

        {/* 分辨率选了4k */}
        {is4k && (
          <>
            <CutDiffProportion disabled={!isHighUser} />
            <CfgScale1 disabled={!isHighUser} />
            <CfgScale2 disabled={!isHighUser} />
          </>
        )}

        {/* 画面描述匹配度-备注：部分模型不支持该参数 */}
        {!isNullOrUndefined(clipSkip) && !isFlux && (
          <ClipSkipComp disabled={!isHighUser} />
        )}

        {/* ENSD-备注：部分模型不支持该参数 */}
        {!isNullOrUndefined(ensd) && !isFlux && (
          <EnsdComp disabled={!isHighUser} />
        )}

        {showIfgParams && (
          <>
            <StylizeComp disabled={!isHighUser} />
            <ChaosComp disabled={!isHighUser} />
          </>
        )}
      </div>
    </div>
  )
})
